<template>
    <div class="form-group">
        <div class="alert alert-success" v-if="success" role="alert">
            {{success}}
        </div>
        <div class="alert alert-danger" v-if="danger" role="alert">
            {{danger}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "alert",
        props: ['success', 'danger']
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Alert.vue